import MegaraxClient from "../../megaraxClient";
import { ListDto } from "../../list";

export interface SearchResult {
  app: string;
  resource: string;
  id: number;
  str: string;
}

export const searchResultResource = (client: MegaraxClient) => ({
  async search({
    searchTerm,
    limit = 10,
    offset = 0,
  }: {
    searchTerm: string;
    limit?: number;
    offset?: number;
  }): Promise<ListDto<SearchResult>> {
    const { data } = await client.get("search/search/search/", {
      params: { search: searchTerm, limit, offset },
    });
    return data;
  },
});
